import { z } from "zod";

export const week39PackagingLiveSchema = z.object({
  source: z.literal("MICRO_ERP"),
  observedAt: z.iso.datetime(),
  range: z.object({ from: z.iso.date(), to: z.iso.date() }),
  latestEntry: z.object({ date: z.iso.date(), workOrderNo: z.string().min(1), mikroWorkOrderNo: z.string().optional(),
    productCode: z.string().min(1), quantity: z.number().finite(), unit: z.string().nullable(), recordedAt: z.string().nullable(), documentNo: z.string().nullable() }).nullable().optional(),
  latestEntryUnavailable: z.boolean().optional(),
  countryLookupUnavailable: z.boolean().optional(),
  workOrderMatches: z.array(z.object({ excelWorkOrderNo: z.string().min(1), mikroWorkOrderNo: z.string().min(1), productCode: z.string().min(1) })).optional(),
  workOrders: z.array(z.object({
    workOrderNo: z.string().min(1),
    found: z.boolean(),
    statusCode: z.number().int().nullable(),
  })),
  items: z.array(z.object({
    date: z.iso.date(),
    workOrderNo: z.string().min(1),
    mikroWorkOrderNo: z.string().optional(),
    productCode: z.string().min(1),
    productName: z.string().optional(),
    country: z.string().min(1).nullable().optional(),
    quantity: z.number().finite(),
    unit: z.string().nullable(),
    recordedAt: z.string().nullable(),
    documentNo: z.string().nullable(),
    batchCode: z.string().nullable().optional(),
    lotNo: z.string().nullable().optional(),
  })),
});
